import Spinner from "react-bootstrap/Spinner";

export default function OrderLoader(props) {
    
    const isWebOrder = props.urlConfig.Type === '' || props.urlConfig.Type === null || props.urlConfig.Type === 'null' || props.urlConfig.Type === 'web' ? true : false;
    const isDelivery = props.urlConfig.MenuType === 'delivery';

    if (isWebOrder) { // Web Ordering
        return (
            <>
                <div className="text-center mt-2 pt-1 mb-1" style={{paddingBottom: "3px"}}>
                    <Spinner animation="border" role="status" variant="secondary" size="sm" className="ms-2 mb-n3" style={{height: "25px", width: "25px"}}></Spinner>
                </div>
                <div className="border border-light-subtle border-2 rounded-3 mb-5 p-3 p-sm-4">
                    <div className="row gap-2">
                        <div className="col-12 text-center">
                            <div className="placeholder placeholder-wave bg-secondary col-2" style={{height: "20px"}}></div><br />
                            <div className="placeholder placeholder-wave bg-secondary col-3"></div><br />
                            <div className="mt-4 pb-2"></div>
                            <div className="placeholder placeholder-wave bg-secondary col-6 rounded"></div><br />
                            <div className="placeholder placeholder-wave bg-secondary col-3 mt-2"></div><br />
                            <div className="mt-2 pt-1"></div>
                            { isDelivery ? 
                            <>
                                <div className="placeholder placeholder-wave bg-secondary col-6 mt-4 rounded" style={{height: "128px"}}></div>
                                <br />
                            </>
                            :
                            <>
                                <div className="placeholder placeholder-wave bg-secondary col-6 mt-4 rounded" style={{height: "112px"}}></div><br />
                                <div className="placeholder placeholder-wave bg-secondary col-6 mt-4 rounded-pill" style={{height: "37px"}}></div><br />
                            </>
                         }
                        </div>
                    </div>
                </div>
            </>
        )
    } else { // Not Web Order
        return (
            <>
                <div className="text-center mt-2 pt-1 mb-1" style={{paddingBottom: "3px"}}>
                    <Spinner animation="border" role="status" variant="secondary" size="sm" className="ms-2 mb-n3" style={{height: "25px", width: "25px"}}></Spinner>
                </div>
                <div className="border border-light-subtle border-2 rounded-3 mb-5 p-3 p-sm-4">
                    <div className="row gap-2">
                        <div className="col-12 text-center">
                            <div className="placeholder placeholder-wave bg-secondary col-2" style={{height: "20px"}}></div><br />
                        </div>
                    </div>
                </div>
            </>
        )
    }
}